<template>
	<div class="text-left" @click="$emit('click', $event)" v-if="isConditionMet">
		<div class="form-question"><span class="question-content" v-html="questionHtml(item.question)"></span> <span v-if="item.required" class="font-red brand-medium">*</span>  <v-icon v-if="showConditionalHelper" small color="gray_50">account_tree</v-icon></div>
		<v-form @submit.prevent v-model="isValid" lazy-validation ref="form">
			<v-radio-group
				v-model="selection"
				:key="refreshKey"
				hide-details
				dense
				:row="!item.formatVertically"
				:rules="item.required ? radioInputRequired : []"
				class="mt-0 brand-choice-group"
				@change="handleChange()"
			>
				<v-radio
					:disabled="disabled"
					class="form-checkbox form-input"
					v-for="(option, index) in item.options"
					:key="index"
					:value="option"
					:label="option"
					dense
					hide-details
				></v-radio>
				<div v-if="item.hasOther" class="row-format align-center gap-2 other-choice">
					<v-radio
						:disabled="disabled"
						class="form-checkbox form-input"
						:value="otherOption"
						:label="otherLabel"
						dense
						hide-details
					></v-radio>
					<v-text-field
						v-model="otherText"
						:disabled="disabled"
						:outlined="outlined"
						:solo="solo"
						:filled="filled"
						:aria-label="otherLabel"
						:placeholder="otherHint"
						class="form-input other-text"
						hide-details
						dense
						@input="handleOtherInput()"
					></v-text-field>
				</div>
			</v-radio-group>
		</v-form>
	</div>
</template>

<script>
	import RendererMixin from '@/modules/forms/v2/schema/RendererMixin';
	import { OTHER_OPTION, otherAnswerValues, otherChoiceLabel, otherPlaceholder, splitOtherAnswer } from '@/modules/forms/v2/schema/otherOption';

	export default {
		name: 'Radio',

		props: ['disabled', 'item', 'styles', 'index','results','builder','container'],

		mixins: [RendererMixin],

		data: function() {
			return {
				refreshKey: 1,
				selection: null,
				otherText: '',
				otherOption: OTHER_OPTION,
			};
		},

		mounted() {
			let currentResult = this.getCurrentResult(this.item.id,this.results);
			if(currentResult){
				const { selection, otherText } = splitOtherAnswer(this.item, currentResult);
				this.selection = selection.length ? selection[0] : null;
				this.otherText = otherText;
			}
		},

		beforeDestroy() {},

		methods: {
			handleChange: function(){
				this.$emit('input', {item: this.item, value: this.answerValue, index: this.index, container: this.container});
			},

			// Typing an Other answer selects the Other choice.
			handleOtherInput: function () {
				if (this.otherText.trim()) this.selection = OTHER_OPTION;
				this.handleChange();
			},
		},

		computed: {
			otherLabel() {
				return otherChoiceLabel(this.item, this.$t('discovery.other'));
			},

			otherHint() {
				return otherPlaceholder(this.item);
			},

			answerValue() {
				const [value = null] = otherAnswerValues(this.selection, this.otherText);
				return value;
			},

			radioInputRequired() {
				return [!!this.answerValue || 'Required'];
			},
		},

		watch: {
			'item.options': {
				deep: true,
				handler: function() {
					this.refreshKey++;
				},
			},
		},
	};
</script>

<style scoped lang="scss">
	.form-checkbox {
		.v-label {
			color: var(--font-color)!important;
		}
		.v-input--selection-controls__input {
			margin-right: 0px !important;
		}
	}

	.other-choice .other-text {
		flex: 0 1 240px;
		min-width: 140px;
	}
</style>
